import React from 'react';
import { IconProps } from './IconTypes';

const ChinaLogo: React.FC<IconProps> = ({ 
  size = 16, 
  color = "currentColor",
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={size} 
      height={size}
      viewBox="2 2 95 95" 
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M51.3,56c-0.3-1.2,0.1-2.4,1-3.2L65,41.9c2.2-1.9,1-5.4-1.8-5.6l-16.6-1.4c-1.2-0.1-2.2-0.9-2.7-2l-6.4-15.4
          c-1.1-2.6-4.8-2.6-5.9,0L25.1,33c-0.5,1.1-1.5,1.9-2.7,2L5.7,36.3c-2.8,0.2-4,3.8-1.8,5.6l12.7,10.9c0.9,0.8,1.3,2,1,3.2
          l-3.9,16.2c-0.7,2.8,2.4,5,4.8,3.5L32.8,67c1-0.6,2.3-0.6,3.3,0l14.3,8.7c2.4,1.5,5.5-0.7,4.8-3.5L51.3,56z" />
        <path d="M96.9,62c0.6-0.6,0.3-1.6-0.6-1.7l-5-0.4c-0.4,0-0.7-0.3-0.8-0.6l-1.9-4.6c-0.3-0.8-1.4-0.8-1.8,0l-1.9,4.6
          c-0.1,0.3-0.5,0.6-0.8,0.6l-5,0.4c-0.9,0.1-1.2,1.1-0.5,1.7l3.8,3.3c0.3,0.2,0.4,0.6,0.3,1l-1.2,4.9c-0.2,0.8,0.7,1.5,1.4,1
          l4.3-2.6c0.3-0.2,0.7-0.2,1,0l4.3,2.6c0.7,0.4,1.6-0.2,1.4-1l-1.2-4.9c-0.1-0.4,0-0.7,0.3-1L96.9,62z" />
        <path d="M77.6,86.1c-0.3-0.2-0.4-0.6-0.4-0.9l0.9-4.9c0.2-0.8-0.8-1.5-1.5-1l-4.1,2.8c-0.3,0.2-0.7,0.2-1,0.1l-4.4-2.4
          c-0.8-0.4-1.6,0.3-1.4,1.1l1.4,4.8c0.1,0.3,0,0.7-0.3,1l-3.6,3.4c-0.6,0.6-0.2,1.6,0.6,1.7l5,0.1c0.4,0,0.7,0.2,0.8,0.5l2.2,4.5
          c0.4,0.8,1.5,0.7,1.8-0.1l1.7-4.7c0.1-0.3,0.4-0.6,0.8-0.6l5-0.7c0.8-0.1,1.1-1.2,0.5-1.7L77.6,86.1z" />
        <path d="M82.9,33.6c0.1,0.4-0.1,0.7-0.4,0.9l-4,3.1c-0.7,0.5-0.4,1.6,0.5,1.7l4.9,0.7c0.4,0,0.7,0.3,0.8,0.6l1.7,4.7
          c0.3,0.8,1.4,0.9,1.8,0.1l2.2-4.5c0.2-0.3,0.5-0.5,0.8-0.5l5-0.1c0.9,0,1.3-1.1,0.6-1.7l-3.6-3.4c-0.3-0.2-0.4-0.6-0.3-1l1.4-4.8
          c0.2-0.8-0.6-1.5-1.4-1.1l-4.4,2.4c-0.3,0.2-0.7,0.2-1-0.1l-4.1-2.8c-0.7-0.5-1.6,0.1-1.5,1L82.9,33.6z" />
        <path d="M67.2,13c0.2,0.3,0.3,0.6,0.2,1l-1.7,4.7c-0.3,0.8,0.5,1.6,1.3,1.2l4.5-2.1c0.3-0.2,0.7-0.1,1,0.1l4,3
          c0.7,0.5,1.6,0,1.5-0.9l-0.6-5c0-0.4,0.1-0.7,0.4-0.9l4.1-2.8c0.7-0.5,0.5-1.6-0.4-1.7l-4.9-0.9c-0.4-0.1-0.7-0.3-0.8-0.7l-1.4-4.8
          c-0.2-0.8-1.4-0.9-1.8-0.2l-2.4,4.4c-0.2,0.3-0.5,0.5-0.9,0.5l-5-0.1c-0.9,0-1.3,1-0.7,1.6L67.2,13z" />
      </g>
    </svg>
  );
};

export default ChinaLogo;